module.exports = __webpack_public_path__ + "ef323eb438d0338eb058776a48ce6235.png";